import { Component, OnInit,Input, EventEmitter, Output } from '@angular/core';
import { ApiService } from '../api.service';
import { ObservablesService } from '../observables.service';
@Component({
  selector: 'app-level-selector',
  templateUrl: './level-selector.component.html',
  styleUrls: ['./level-selector.component.scss']
})
export class LevelSelectorComponent implements OnInit {
  @Output() onUserSelected: EventEmitter<any> = new EventEmitter<any>();
  users:any=[]
  selectData:any=[]
  selectedUsers:any=[]
  goBtnStatus:boolean = false;
  lastSelectedUser:any;
  selectedClient:any;
  loggedUserInfo:any=[];
  treeData:any=[];
  directUsers:any=[];

  constructor(private api:ApiService,private observables:ObservablesService) { }

  ngOnInit() {
    this.observables.refreshSelectStatus.subscribe(()=>{
      this.selectData.length =[];
      console.log("abcd=")
      setTimeout(()=>{
        this.selectData.push(this.directUsers)
        this.goBtnStatus = false
      },0)
    })
    this.api.getLoggedUserInfo().then((res:any)=>{
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];
        // console.log("this.loggedUserInfo=",this.loggedUserInfo)
        this.getUsers()
      }else{
        this.api.logOut()
      }
    })
  }


  itemChanged(event,i){
    if(this.selectData.length > i+1){
      this.selectData.length = i+1;// removing other elements after an index

    }

    if(event.value.children.length > 0 && event.value.children[0].is_last_level == 0){
      this.goBtnStatus = true
      this.selectData.push(event.value.children);
      this.lastSelectedUser = event.value;
    }else if(event.value.children.length > 0 && event.value.children[0].is_last_level == 1){
      this.lastSelectedUser = event.value;
      this.goBtnStatus = true
    }else{
      this.goBtnStatus = true
    }

    // console.log("selectData==",this.selectData);
  }


  getFilteredUsers(){
    this.selectedUsers = [];
    this.getAllRecursiveUsers(this.lastSelectedUser.children)

  }

  getAllRecursiveUsers(data){

    data.filter((item: any,i) =>{

      if(item.children.length > 0 && item.is_last_level == 0){
          // this.selectedUsersList.push({name:item.full_name,role:item.role})
        this.getAllRecursiveUsers(item.children)
      }else if(item.children.length == 0 && item.is_last_level == 1){
        this.selectedUsers.push(item)
      }

      if(i == data.length -1){
        this.onUserSelected.emit(this.selectedUsers);
      }
    })
  }

  getUsers(){
    this.api.send('findDb',{
      table:'users as U',
      fields:['U.id as id','U.full_name','R.role','R.level','R.is_last_level','U.role_id','U.parent_id'],
      joins:[{
        type:"left",
        table:'roles as R',
        conditions:["R.id = U.role_id"]
      }],
      conditions:[{'U.business_id':this.loggedUserInfo.business_id}]
    }).then((result:any)=>{
      this.users=result.data
      // console.log("users=",this.users)

      var idToNodeMap = {};
      var root = null;
      var parentNode;
      for(var i = 0; i < this.users.length; i++) {
          var datum = this.users[i];
          datum.children = [];
          idToNodeMap[datum.id] = datum;

          if(!datum.parent_id) {
              root = datum;
          } else {
              parentNode = idToNodeMap[datum.parent_id];
              parentNode.children.push(datum);
          }
      }

      this.treeData.push(root)
      // console.log("this.dataSource.data=",this.treeData);
      // this.selectData.push(this.treeData[0].children)
      this.getLoggedUserTreeData(this.treeData,this.loggedUserInfo.level,this.loggedUserInfo.id)
    })
  }

  getLoggedUserTreeData(data,level,id){

    for(let i=0;i<data.length;i++){
      if(data[i].level == level && data[i].id == id){
        if(data[i].children.length > 0){
          this.selectData.push(data[i].children)
          this.directUsers = data[i].children;
          // this.getAllRecursiveUsers(data[i].children)
        }else{
          this.selectedUsers =[]
        }
        break;
      }else{

        if(data[i].children.length > 0 && data[i].is_last_level == 0){
          this.getLoggedUserTreeData(data[i].children,level,id)
        }
      }
    }
  }

}
